export default "./eye.svg"